import { createRoute } from '@tanstack/react-router';
import { SitePreview } from '../components/site-panel.tsx';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: '/', component: SitePreview });
